import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getConfigDefList(params) {
  return request({
    url: URL.sys.configDef,
    method: 'get',
    params
  })
}

export function saveConfigDef(data) {
  return request({
    url: URL.sys.configDef,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delConfigDef(uuid) {
  return request({
    url: URL.sys.configDef + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 保存信控配置
export function saveCreditConfig(data) {
  return request({
    url: URL.sys.saveCreditConfig,
    method: 'post',
    data
  })
}
